import React from 'react';
import { useState } from 'react';
import helpHover from '../Investment/Images/ionic-ios-information-circle-outline.svg';
import { CommaSeprator, convertIntoLakh, decimaNumberFormat } from './UtilityComponents/UtilityFunction';

const TaxSaving = ({ ClosePopup, QuoteData, TaxSlabAmount, TaxSlabAmount10D, TotalTaxSaving, CessAmount, TaxSlab, fourCess }) => {

    console.log({ QuoteData })
    //const [TaxShow, setTaxShow] = useState(true)
    //const [ToolTip, setToolTip] = useState(true)

    return (
        <>
            <div className="TaxSavingMainPage">
                <div className="TaxSavingPage">
                    <section>
                        <div className="TaxSavingTop">
                            <span className="TaxHead">
                                Tax Savings on Investment
                            </span>

                            <span onClick={() => ClosePopup(false)} className="closebutton">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" ><path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path></svg>
                            </span>
                        </div>
                    </section>
                    <hr className="mb-2" />
                    <div className="TaxSavingBottom">
                        <div className="InvestUnderSec">
                            <span>UNDER SECTION 80C</span>
                        </div>
                        <section className="p-2">
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Investment Amount per year</span>
                                <span className="InvestTotal"> ₹{CommaSeprator(decimaNumberFormat(QuoteData?.TotalInvestmentAmountPerYear))}</span>
                            </div>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Investment Years</span>
                                <span className="InvestTotal">{QuoteData?.PaymentTerm} Year</span>
                            </div>
                            <div className="BenefitsDetails">
                                <span className="InvestTotal">Total Investment Amount</span>
                                <span className="InvestTotal">₹{convertIntoLakh(QuoteData?.TatalInvestmentAmount)}</span>
                            </div>
                            <hr className="DivideLine" />
                            <div className="BenefitsDetails">
                                <div className="d-flex align-items-center">
                                    <span className="InvestTotals">Tax savings in {QuoteData?.PaymentTerm} years</span>
                                    <div className="TaxPopUp">
                                        <img src={helpHover} class="TaxImage" alt="More info." />
                                        <div className="ToolTipPos">
                                            <div className="ToolTipW">
                                                <section className="ToolTipP">
                                                    {/*<span  className="closebutton CrossIcon">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" ><path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path></svg>
                                                    </span>*/}
                                                    <div className="ToolTipContent">
                                                        <span>Investment Amount ({QuoteData?.PaymentTerm} years)</span>
                                                        <span>₹{CommaSeprator(decimaNumberFormat(QuoteData?.TatalInvestmentAmount))}</span>
                                                    </div>
                                                    <div className="ToolTipContent">
                                                        <span>30% Tax Slab</span>
                                                        <span>₹{CommaSeprator(decimaNumberFormat(QuoteData?.ThirtyTaxSlab))}</span>
                                                    </div>
                                                    <div className="ToolTipContent">
                                                        <span>4% Cess</span>
                                                        <span>₹{CommaSeprator(decimaNumberFormat(QuoteData?.fourcess))}</span>
                                                    </div>
                                                    <hr className="BreakLine" />
                                                    <div className="ToolTipContent">
                                                        <span><strong>Tax Savings in {QuoteData?.PaymentTerm} years</strong></span>

                                                        <span><strong>₹{CommaSeprator(decimaNumberFormat(QuoteData?.TaxSavingTenYear))}</strong></span>
                                                    </div>
                                                </section>
                                                <div class="arrow-up"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span className="InvestTotal"><b>₹{CommaSeprator(decimaNumberFormat(QuoteData?.TaxSavingTenYear))}</b></span>
                            </div>
                        </section>
                        <section className="mt-3">
                            <div className="InvestUnderSec">
                                <span>UNDER SECTION 10 (10D)</span>
                            </div>
                            <div className="BenefitsDetails p-2">
                                <span className="InvestTotal">Maturity Amount</span>
                                <span className="InvestTotal">₹{CommaSeprator(Math.round(QuoteData?.MaturityBenefit))}</span>
                            </div>
                            <hr className="DivideLine" />
                            <div className="BenefitsDetails">
                                <div className="d-flex align-items-center">
                                    <span className="InvestTotals">Tax savings on returns</span>
                                    <div className="TaxPopUp">
                                        <img src={helpHover} class="TaxImage" alt="More info." />
                                        <div className="ToolTipPos">
                                            <div className="ToolTipW">
                                                <section className="ToolTipP">
                                                    {/*<span  className="closebutton CrossIcon">
                                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" ><path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path></svg>
                                                    </span>*/}
                                                    <div className="ToolTipContent">
                                                        <span>Maturity Amount</span>
                                                        <span>₹{CommaSeprator(Math.round(QuoteData?.MaturityBenefit))}</span>
                                                    </div>
                                                    <div className="ToolTipContent">
                                                        <span>Invested Amount</span>
                                                        <span>-₹{CommaSeprator(decimaNumberFormat(QuoteData?.TatalInvestmentAmount))}</span>
                                                    </div>
                                                    <hr className="BreakLine" />
                                                    <div className="ToolTipContent">
                                                        <span><b>31.2% Tax Slab Rate (Including Cess)</b></span>
                                                        <span><b>₹{CommaSeprator(decimaNumberFormat(QuoteData?.taxsalbrate))}</b></span>
                                                    </div>
                                                </section>
                                                <div class="arrow-up"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span className="InvestTotal"><b>₹{CommaSeprator(decimaNumberFormat(QuoteData?.TexSavingonReturn))}</b></span>
                            </div>
                        </section>
                    </div>
                    <div className="TotalTaxSave">
                        <span className="InvestTaxSave ">Total Tax Savings</span>
                        <span className="InvestTaxSave">₹{CommaSeprator(decimaNumberFormat(TotalTaxSaving))}</span>
                    </div>
                    <div className="TaxButton">
                        <button value="" className="TaxGotIt" onClick={() => ClosePopup(false)}>Got It</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TaxSaving;